module.exports = __webpack_public_path__ + "static/media/video.5beb64ef.png";